import useQueryParams from 'hooks/useQueryParams';

const useSearchParams = () => {
  const { searchParams } = useQueryParams();

  return searchParams;
};

export default useSearchParams;
